import { call, put, takeLatest, select } from 'redux-saga/effects'
import { getPersistor } from 'store/configureStore'
import { LOAD_CONFIGURATION, loadConfigurationFailed, loadConfigurationFinished } from 'store/actions/searchAction'
import { getCountryCode, getConfigurationSelector } from 'store/selectors/configurationSelector'

import { fetchSearchConfig } from 'api/searchApi'
import { v4 as uuidv4 } from 'uuid'

export function * loadConfigurationHandler(action) {
  const persistor = yield call(getPersistor)
  yield call(persistor.purge)
  const configData = yield select(getConfigurationSelector)
  const countryCode = yield call(getCountryCode, configData.auDomains, configData.nzDomains)
  sessionStorage.setItem('countryCode', countryCode)
  sessionStorage.setItem('integratorName', action.payload)
  sessionStorage.setItem('sessionId', uuidv4())

  try {
    const { data: searchConfigData } = yield call(fetchSearchConfig, action.payload, countryCode)

    // catch downstream service errors in the API
    if (searchConfigData.errors && searchConfigData.errors.length > 0) {
      yield put(loadConfigurationFailed(searchConfigData.errors))
      return
    }

    // Session Storage
    sessionStorage.setItem('integratorName', searchConfigData.integratorName)

    // Local Storage
    localStorage.setItem('uniqueCookieId', configData.uniqueCookieId)

    yield put(loadConfigurationFinished(searchConfigData))
  } catch (e) {
    yield put(loadConfigurationFailed(e.message))
  }
}

export default function * watchSearchSaga() {
  yield takeLatest(LOAD_CONFIGURATION, loadConfigurationHandler)
}
